import React from 'react';
import PropTypes from 'prop-types';
import { ChevronsLeft, Search } from 'lucide-react';
import Notifications from "../Components/Notifications";

export const Header = ({ collapsed, setCollapsed }) => {
  return (
    <header className="relative z-10 flex h-[60px] items-center justify-between bg-[#0a0a0a] px-4 border-b border-gray-800">
      
      {/* Left: Chevron button */}
      <div className="flex items-center gap-x-3">
        <button
          className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-800 transition-colors"
          onClick={() => setCollapsed(!collapsed)}
        >
          <ChevronsLeft 
            className={`${collapsed ? 'rotate-180' : ''} transition-transform text-gray-400`}
            size={20}
          />
        </button>
      </div>

      {/* Center: Search Bar */}
      <div className="flex-1 max-w-xl mx-4 relative">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" />
        <input
          type="text"
          placeholder="Search migrations..."
          className="w-full bg-[#141414] border border-gray-800 rounded-lg pl-12 pr-4 py-2.5 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-gray-500 transition-colors"
        />
      </div>

      {/* Right: Notifications + Profile */}
      <div className="flex items-center gap-4">
        <Notifications />
        <div className="w-10 h-10 bg-gradient-to-br from-gray-500 to-gray-700 rounded-full flex items-center justify-center text-sm font-semibold text-white cursor-pointer hover:opacity-90 transition-opacity">
          DF
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  collapsed: PropTypes.bool,
  setCollapsed: PropTypes.func,
};